import React from 'react'
import classnames from '@utils/classnames'
import Section from '@components/section'
import PartTitle from '@components/partTitle'
import styles from './worlds.module.scss'

const Worlds = React.memo((props) => {
  return (
    <Section>
      <PartTitle en="PART 03">位面冒险</PartTitle>
      <div className={styles.worlds}>
        <div className="placeholder">1</div>
        <div className="placeholder">1</div>
        <div className="placeholder">1</div>
        <div className="placeholder">1</div>
      </div>
      <div className="infoBox">
        <h3>位面的冒险,从核聚变正式开始</h3>
        <p>这里是说明文字</p>
      </div>
    </Section>
  )
})

Worlds.displayName = 'ArcWorlds'
export default Worlds